import { Button, EmptyState, Search } from '@blend-ed/blendx-ui'
import React, { useState } from 'react'
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n'
import CarouselContainer from '../../components/CarouselContainer'
import RecommendedCourses from '../home/recommended-courses'
import RecommendedPrograms from '../home/recommended-programs'
import messages from './messages'
import { gql, useQuery } from '@apollo/client'

const TAGS_USER_USED = gql`
    query TagsUserHasUsed($userId: Int4!) {
        courseTags(
            where: {
            course: { courseEnrollments: { userId: { _eq: $userId } } }
            }
        ) {
            tag
        }
        programTags (
            where: {
                program: { programEnrollments: { userId: { _eq: $userId } } }
            }
        ) {
            tag
        }
    }
`

const RECOMMENDED_TAGS = gql`
    query GetRemainingTags($excludedTags: [Text!]) {
        tags(
            where: {
                tag: {_not: {_in: $excludedTags}}
            }
        ) {
            tag
        }
    }
`

function Discover({ intl }) {
    const [search, setSearch] = useState('')
    const [searchTags, setSearchTags] = useState([])
    const [hasCoursesResults, setHasCoursesResults] = useState('loading')
    const [hasProgramResults, setHasProgramResults] = useState('loading')

    const { data: userTagsData, loading: userTagsLoading, error: userTagsError } = useQuery(TAGS_USER_USED, {
        variables: {
            userId: 1
        },
        context: {
            headers: {
                'x-hasura-role': 'learner'
            }
        },
    })

    const { data: recommendedTagsData, loading: recommendedTagsLoading, error: recommendedTagsError } = useQuery(RECOMMENDED_TAGS, {
        variables: {
            excludedTags: [
                ...(userTagsData?.courseTags?.map(tag => tag.tag) || []),
                ...(userTagsData?.programTags?.map(tag => tag.tag) || [])
            ]
        },
        context: {
            headers: {
                'x-hasura-role': 'learner'
            }
        },
        skip: userTagsLoading,
    })


    if (userTagsLoading || recommendedTagsLoading) return null

    const tags = recommendedTagsData?.tags?.map(tag => tag.tag) || []

    const handleTagClick = (tag) => {
        if (searchTags.includes(tag)) {
            setSearchTags(searchTags.filter(t => t !== tag))
        } else {
            setSearchTags([...searchTags, tag])
        }
    }

    return (
        <main>
            <CarouselContainer />
            {/* Search section */}
            <div className="search-section">
                <span className='search-section__heading'>{intl.formatMessage(messages.searchHeading)}</span>
                <Search
                    placeholder={intl.formatMessage(messages.searchPlaceholder)}
                    className="search-section__search-bar"
                    value={search}
                    onChange={(e) => setSearch(e)}
                />
                <div className="search-tags">
                    {tags.map((tag, index) => (
                        <Button variant={searchTags.includes(tag) ? "outline-primary" : "outline-gray"} onClick={() => handleTagClick(tag)} key={index} size="xs">{tag}</Button>
                    ))}
                </div>
            </div>

            <RecommendedCourses
                search={search}
                searchTags={searchTags}
                noData={() => setHasCoursesResults('empty')}
                hasData={() => setHasCoursesResults('complete')}
            />
            <RecommendedPrograms
                search={search}
                searchTags={searchTags}
                noData={() => setHasProgramResults('empty')}
                hasData={() => setHasProgramResults('complete')}
                compact={true}
            />

            {
                hasCoursesResults === 'empty' && hasProgramResults === 'empty' && (
                    <EmptyState type="search" className="mt-6" message={intl.formatMessage(messages.noResultsFound)} />
                )
            }
        </main >
    )
}

Discover.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Discover);